import module from 'nominas/nomina/module.js'

export class NominasNominaBancosRecibosPagosService {
  constructor ($http) {
    this.$http = $http
  }

  get (pagos, idNomina) {
    return this.$http.get('/api/nominas/nomina/bancos/pagos/recibos-bancarios', {
      params: {
        pagos: pagos,
        id_nomina: idNomina,
      },
      download: true,
    })
  }
}

module.service('NominasNominaBancosRecibosPagos', NominasNominaBancosRecibosPagosService)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Bancos/Recibos/RecibosPagos.js